/* Routine showcase behavior (sections/ck-routine-showcase.liquid):
   - crossfading media stage driven by the active step
   - optional autoplay with a linear progress bar per step
   - pauses while hovered/focused or off-screen; stops for good once the
     shopper clicks a step themselves; disabled under reduced motion */
(function () {
  if (window.ckRsLoaded) return;
  window.ckRsLoaded = true;

  function init(root) {
    if (root.dataset.ckRsInit === 'true') return;
    root.dataset.ckRsInit = 'true';

    var items = Array.prototype.slice.call(root.querySelectorAll('[data-ck-rs-item]'));
    var medias = Array.prototype.slice.call(root.querySelectorAll('[data-ck-rs-media]'));
    var counter = root.querySelector('[data-ck-rs-count]');
    if (!items.length) return;

    // Backstop for cached HTML that still carries loading="lazy": stacked
    // opacity-0 slides are skipped by lazy heuristics, so force-load them.
    medias.forEach(function (m) {
      var img = m.querySelector('img');
      if (img && !img.complete && img.loading === 'lazy') {
        img.loading = 'eager';
        img.src = img.src;
      }
    });

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplay = root.dataset.autoplay === 'true' && !reduced && items.length > 1;
    var duration = (parseInt(root.dataset.duration, 10) || 5) * 1000;
    var idx = 0;
    var timer = null;
    var inView = false;
    var paused = false;
    var stopped = false;

    function rectVisible() {
      var r = root.getBoundingClientRect();
      return r.bottom > 0 && r.top < window.innerHeight;
    }

    /* Entrance-hide is opt-in via JS: only sections currently below the fold
       get hidden for the staggered reveal. If this script never runs, the
       section is simply visible — no-JS shoppers lose nothing. */
    if (!reduced && !rectVisible()) {
      root.classList.add('ck-rs--anim');
    }

    function clearFills() {
      items.forEach(function (item) {
        var fill = item.querySelector('[data-ck-rs-fill]');
        if (!fill) return;
        fill.style.transition = 'none';
        fill.style.width = '0%';
      });
    }

    function stop() {
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }
      clearFills();
    }

    function canPlay() {
      return autoplay && !stopped && !paused && inView;
    }

    function play() {
      stop();
      if (!canPlay()) return;
      var fill = items[idx].querySelector('[data-ck-rs-fill]');
      if (fill) {
        // force the 0% start before animating so the bar restarts cleanly
        void fill.offsetWidth;
        fill.style.transition = 'width ' + duration + 'ms linear';
        fill.style.width = '100%';
      }
      timer = setTimeout(function () {
        activate(idx + 1, false);
      }, duration);
    }

    function activate(next, fromUser) {
      idx = (next + items.length) % items.length;
      items.forEach(function (item, j) {
        var on = j === idx;
        item.classList.toggle('is-active', on);
        var row = item.querySelector('.ck-rs__row');
        if (row) row.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
      medias.forEach(function (media, j) {
        media.classList.toggle('is-active', j === idx);
      });
      if (counter) counter.textContent = String(idx + 1);
      if (fromUser) {
        stopped = true;
        stop();
        return;
      }
      play();
    }

    items.forEach(function (item, j) {
      var row = item.querySelector('.ck-rs__row');
      if (!row) return;
      row.addEventListener('click', function () {
        // clicking the already-active step is a no-op (and must not kill autoplay)
        if (j === idx) return;
        activate(j, true);
      });
    });

    /* pause (don't kill) autoplay while the shopper is reading/hovering.
       Mouse pointers only: iOS touch fires pointerenter without a reliable
       pointerleave, which would stick autoplay in the paused state. */
    root.addEventListener('pointerenter', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      paused = true;
      stop();
    });
    root.addEventListener('pointerleave', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      paused = false;
      play();
    });
    root.addEventListener('focusin', function () {
      paused = true;
      stop();
    });
    root.addEventListener('focusout', function (e) {
      if (root.contains(e.relatedTarget)) return;
      paused = false;
      play();
    });

    if ('IntersectionObserver' in window) {
      // keep a reference on the element so the observer can't be collected
      root.ckRsObserver = new IntersectionObserver(
        function (entries) {
          // last entry = most recent state (enter+exit can batch into one call)
          inView = entries[entries.length - 1].isIntersecting;
          if (inView) {
            root.classList.add('is-inview');
            play();
          } else {
            stop();
          }
        },
        { threshold: 0.25 }
      );
      root.ckRsObserver.observe(root);
    }

    /* Observer notifications can be delayed (throttled/occluded tabs) — if the
       section is already on screen, reveal and start immediately, and keep a
       cheap scroll nudge armed until the reveal has happened. */
    function reveal() {
      inView = true;
      root.classList.add('is-inview');
      play();
    }

    function nudge() {
      if (!root.isConnected || root.classList.contains('is-inview')) {
        window.removeEventListener('scroll', onNudgeScroll);
        return;
      }
      if (rectVisible()) {
        reveal();
        window.removeEventListener('scroll', onNudgeScroll);
      }
    }

    function onNudgeScroll() {
      window.requestAnimationFrame(nudge);
    }

    if (rectVisible() || !('IntersectionObserver' in window)) {
      reveal();
    } else {
      window.addEventListener('scroll', onNudgeScroll, { passive: true });
    }

    /* theme-editor re-renders: release everything this init grabbed */
    root.ckRsCleanup = function () {
      stop();
      window.removeEventListener('scroll', onNudgeScroll);
      if (root.ckRsObserver) root.ckRsObserver.disconnect();
    };
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-ck-rs]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);

  document.addEventListener('shopify:section:unload', function (e) {
    Array.prototype.forEach.call(e.target.querySelectorAll('[data-ck-rs]'), function (root) {
      if (typeof root.ckRsCleanup === 'function') root.ckRsCleanup();
    });
  });

  /* Theme editor: clicking a Step block activates it in the preview */
  document.addEventListener('shopify:block:select', function (e) {
    var item = e.target;
    if (!item || !item.hasAttribute || !item.hasAttribute('data-ck-rs-item')) return;
    var root = item.closest('[data-ck-rs]');
    if (!root) return;
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-ck-rs-item]'));
    var j = items.indexOf(item);
    if (j < 0) return;
    var row = item.querySelector('.ck-rs__row');
    if (row) row.click();
  });
})();
